export const resize = (
  src: string,
  width: number,
  height: number,
  options?: {
    crop?: boolean
  }
): string => {
  return `${src}?width=${width}&height=${height}&optimize=high&format=pjpg&auto=webp&quality=85,75${
    options?.crop ? '&fit=fit34' : ''
  }`
}
